import { PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import {
  all, call, put, select, takeEvery, takeLatest,
} from 'redux-saga/effects'
import { ReturnCall } from 'src/features/types'
import { actions as appActions } from '../state'
import { mapReceivement } from './ReceivementOverviewList.utils'
import apis from './ReceivementOverviewListApi'
import { selectReceivementOverviewListFilters } from './ReceivementOverviewListSelectors'
import { actions } from './ReceivementOverviewListState'
import { GetReceivementOverviewListSagaPayload, GetReceivementStatusListPayload } from './ReceivementOverviewListTypes'

export function* getReceivementOverviewList(data: PayloadAction<GetReceivementOverviewListSagaPayload>) {
  yield put(appActions.isLoading(true))

  try {
    const state = yield select(selectReceivementOverviewListFilters)
    const page = data.payload.page || state.page
    const pageSize = data.payload.pageSize || state.pageSize
    const idFc = state.idFc === '' ? undefined : state.idFc
    const idStatus = state.idStatus === '' ? undefined : state.idStatus
    const idSupplier = state.idSupplier === '' ? undefined : state.idSupplier

    const result: ReturnCall<typeof apis.getReceivementOverviewList> = yield call(
      apis.getReceivementOverviewList,
      {
        ...state, badge: data.payload.badge, page, pageSize, idFc, idStatus, idSupplier,
      },
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar lista de recebimentos!')
      return
    }

    yield put(actions.setReceivementOverviewList({
      receivements: result.data.data.map(mapReceivement),
      totalPages: result.data.meta.totalPages,
      pageSize,
      page,
      totalItems: result.data.meta.totalItems,
    }))
  } catch (error: any) {
    toast.error('Falha ao buscar lista de recebimentos!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getReceivementStatusList(data: PayloadAction<GetReceivementStatusListPayload>) {
  yield put(appActions.isLoading(true))

  try {
    const { badge } = data.payload
    const result: ReturnCall<typeof apis.getReceivementStatusList> = yield call(
      apis.getReceivementStatusList,
      {
        badge,
      },
    )

    if (!result.isOk) {
      toast.error(result?.data?.message || 'Falha ao buscar lista de status do recebimento!')
      return
    }

    yield put(actions.updateOverviewFilterField({ key: 'receivementStatusList', value: result.data }))
  } catch (error: any) {
    toast.error('Falha ao buscar lista de status do recebimento!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* getFilterSuppliers() {
  try {
    const result: ReturnCall<typeof apis.getFilterSuppliers> = yield call(apis.getFilterSuppliers)

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar fornecedores')
      return
    }

    yield put(actions.updateOverviewFilterField({ key: 'suppliers', value: result.data }))
  } catch (error: any) {
    toast.error('Falha ao buscar fornecedores!')
  }
}

export default function* () {
  yield all([
    takeLatest(actions.getReceivementOverviewList.type, getReceivementOverviewList),
    takeEvery(actions.getReceivementStatusList.type, getReceivementStatusList),
    takeLatest(actions.getFilterSuppliers.type, getFilterSuppliers),
  ])
}
